export const SET_ANSWER = 'SET_ANSWER';
export const SET_ANSWERS = 'SET_ANSWERS';
export const DELETE_ANSWER = 'DELETE_ANSWER';
export const SET_QUESTIONNAIRE = 'SET_QUESTIONNAIRE';
export const SET_ALL_ANSWERS = 'SET_ALL_ANSWERS';
